import { useEffect, useState } from 'react'
import InformationErrorModal from './Components/Modals/InformationErrorModal'
import { useAuth } from '../Providers/AuthProvider';

const VersionControl = () => {
    const { logout } = useAuth()
    const [isUpdate, setIsUpdate] = useState(false)
    const [serverVersion, setServerVersion] = useState(null)

    useEffect(() => {
        let intervalId
        const checkVersion = async () => {
            try {
                const response = await fetch('/version.json', { cache: 'no-cache' })
                if (!response.ok) {
                    console.log('Nie można pobrać pliku version.json')
                    return
                }

                const serverData = await response.json()
                const newVersion = serverData.version
                const currentStoredVersion = localStorage.getItem('APP_VERSION')

                if (!currentStoredVersion) {
                    localStorage.setItem('APP_VERSION', newVersion)
                }
                else if (currentStoredVersion !== newVersion) {
                    await localStorage.setItem('APP_VERSION', newVersion)
                    await localStorage.setItem('OLD_APP_VERSION', currentStoredVersion)

                    setIsUpdate(true)
                    if (intervalId) {
                        clearInterval(intervalId)
                    }
                }

            } catch (error) {
                console.log('Błąd sprawdzania wersji:', error)
            }
        }
        checkVersion()
        intervalId = setInterval(checkVersion, 300000) // 5min

        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [])


    const handleUpdate = () => {
        if (serverVersion) {
            localStorage.setItem('APP_VERSION', serverVersion)
        }
        setIsUpdate(false)
        window.location.reload()
        logout(true, true)
    }

    return (
        <InformationErrorModal
            show={isUpdate}
            setShow={handleUpdate}
            title={'Nowa wersja!'}
            message={'Uwaga wykryto nową wersję aplikacji, aby kontynuować niezbędne jest przeładowanie aplikacji!'}
            isError={false}
            isVersionControlInfo={true}
        />
    )
}

export default VersionControl